<template>
  <solo-card>
    <template slot="title">
      <h3>{{$t('PAGE_setpass_title')}}</h3>
      <p>{{ $t('PAGE_setpass_marketing')}}</p>
    </template>
    <template slot="default">
      <b-form @submit.prevent="reset">
        <b-alert
          v-for="(error, key) in requestErrors"
          :key="key"
          show
          variant="danger"
        >
          <small>{{ error.message }}</small>
        </b-alert>
        <b-alert :show="requestState === 'finished'" variant="primary">
          <small>{{$t('PAGE_setpass_password_set')}}</small>
        </b-alert>
        <div class="row px-3">
          <div role="group" class="w-100">
            <b-form-input
              type="password"
              name="password"
              id="id_password"
              aria-describedby="passwordHelo"
              placeholder="Kennwort"
              v-model="password"
              required
            />
          </div>
        </div>

        <b-button
          :disabled="requestState === 'loading'"
          type="submit"
          variant="primary"
          class="w-100 mt-3"
        >
          <span v-if="requestState === 'loading'"> <loader /> </span>
          <span v-else>{{$t('save')}}</span>
        </b-button>
      </b-form>
      <div class="form-group row px-3">
        <p class="mx-auto">
          <small>
            <router-link class="text-secondary" tag="a" :to="{ name: 'login' }">
              {{$t('PAGE_setpass_pw_not_forgotten')}}
            </router-link>
          </small>
        </p>
      </div>
    </template>
  </solo-card>
</template>

<script>
import { mapGetters } from 'vuex';

import Loader from '@/components/Loader';
import SoloCard from '@/components/SoloCard';

export default {
  name: 'resetpass',
  components: { Loader, SoloCard },
  computed: {
    ...mapGetters(['requestState', 'requestErrors']),
  },
  data() {
    return {
      password: '',
    };
  },
  methods: {
    reset() {
      const { uid, token } = this.$router.currentRoute.params;
      this.$store.dispatch('resetPassword', {
        password: this.password,
        uid,
        token,
      });
    },
  },
};
</script>

<style scoped>
.maxW500 {
  max-width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Setpass.vue